import { useKolo } from './use-kolo';
import { useTwyford } from './use-twyford';

export function useKoloOrTwyford(): boolean {
  const isKolo = useKolo();
  const isTwyford = useTwyford();
  return isKolo || isTwyford;
}
